// extracted by mini-css-extract-plugin
export default {"ordermodalmain":"returnorders_ordermodalmain__XXBRD","overlayordermodal":"returnorders_overlayordermodal__Pu2f5"};